import * as React from 'react';

import { APP_HYDRATED_ATTRIBUTE } from '../../../../../constants/hydration';

/**
 * Ставит маркер успешной гидрации на <html>. Рендерится внутри корневого error boundary:
 * если дерево упало до монтирования, маркера не будет, а SsrMarkupFallback поставит data-app-degraded.
 */
export const HydrationMarker: React.FC = () => {
  React.useEffect(() => {
    document.documentElement.setAttribute(APP_HYDRATED_ATTRIBUTE, 'true');
  }, []);

  return null;
};
